// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__1H7md"};